import React from "react";
import { useLocation } from "react-router-dom";

// ** Icons
import CompassOffOutline from "mdi-material-ui/CompassOffOutline";
import ArrowRight from "mdi-material-ui/ArrowRight";

// ** Layout & styles
import UserLayout from "src/layouts/UserLayout";
import { pathWithPreservedSearch } from "src/@core/utils/urlQueryPreservation";
import "src/styles/style-v3.css";

/******************************************************************
 * ##: NotFound
 * Catch-all 404 page (route path="*"): a v3 empty-state panel with
 * the accent icon tile, an "Erro 404" eyebrow and a solid primary
 * action back to the course list. Guests never see it - AuthGuard
 * redirects unknown paths to /login first.
 * @returns {JSX.Element} - the 404 page inside the app shell
 * History:
 * 05-07-2026: Created
 ******************************************************************/
const NotFound = () => {
  const location = useLocation();
  const homeHref = pathWithPreservedSearch("/home", location.search);

  return (
    <UserLayout>
      <div className="spv3">
        <div className="spv3-empty">
          <span className="spv3-empty__icon">
            <CompassOffOutline />
          </span>
          <span className="spv3-eyebrow">Erro 404</span>
          <h1 className="spv3-empty__title">Página não encontrada</h1>
          <p className="spv3-empty__text">
            O endereço que tentaste abrir não existe ou já não está disponível. Volta aos teus cursos para continuares a
            aprender.
          </p>
          <a className="spv3-btn spv3-btn--primary" href={homeHref}>
            Voltar aos cursos
            <ArrowRight className="spv3-btn__arrow" />
          </a>
        </div>
      </div>
    </UserLayout>
  );
};

export default NotFound;
